import "./TickerContent.sass";

/** Renderiza un elemento seguro del ticker, con variantes para contenido y standings. */
export default function TickerItem({ item }) {
  if (!item?.text) return null;

  if (item.type === "standing-phase") {
    return (
      <div className="ticker-item ticker-item--standing-phase">
        <strong>{item.phase}</strong>
      </div>
    );
  }

  if (item.type === "standing") {
    return (
      <div className="ticker-item ticker-item--standing">
        {item.image ? (
          <img
            className="ticker-standing-card__image"
            src={item.image}
            alt={item.name}
            onError={(event) => {
              event.currentTarget.style.visibility = "hidden";
            }}
          />
        ) : (
          <span className="ticker-standing-card__image" aria-hidden="true" />
        )}
        <div className="ticker-standing-card__content">
          <div className="ticker-standing-card__top">
            <span className="ticker-standing-card__position">{item.rank}.</span>
            <span className="ticker-standing-card__name">{item.name}</span>
          </div>
          <span className="ticker-standing-card__points">
            {Array.isArray(item.stats) && item.stats.length ? (
              item.stats.map((stat, index) => (
                <span className="ticker-standing-card__stat" key={`${stat.label}-${index}`}>
                  <span className="ticker-standing-card__stat-label">({stat.label})</span>
                  <span className="ticker-standing-card__stat-value">{stat.value}</span>
                </span>
              ))
            ) : (
              <>
                {item.points}{item.pointsLabel ? ` ${item.pointsLabel}` : ""}
                {item.secondary ? <span className="ticker-standing-card__secondary">{item.secondary}</span> : null}
              </>
            )}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="ticker-item">
      {item.image && (
        <img
          className="ticker-item-image"
          src={item.image}
          alt={item.name + " " + item.rank}
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
      )}
      <span className="ticker-item-text">{item.text}</span>
    </div>
  );
}